import { nsKey } from "../../utils/storage/partnerStorage";

const SIDEBAR_KEY = nsKey("sidebar_open");

const persist = (open) => localStorage.setItem(SIDEBAR_KEY, String(open));

const initState = {
  open:
    localStorage.getItem(SIDEBAR_KEY) !== null
      ? localStorage.getItem(SIDEBAR_KEY) === "true"
      : true,
};

const navSidebarReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_NAV_SIDEBAR":
      persist(action.payload?.open ?? state.open);
      return { ...action.payload };

    case "TOGGLE_NAV_SIDEBAR": {
      const open = !state.open;
      persist(open);
      return { ...state, open };
    }

    case "OPEN_NAV_SIDEBAR":
      persist(true);
      return { ...state, open: true };

    case "CLOSE_NAV_SIDEBAR":
      persist(false);
      return { ...state, open: false };

    case "CLEAR_NAV_SIDEBAR":
      localStorage.removeItem(SIDEBAR_KEY);
      return initState;

    default:
      return state;
  }
};

export default navSidebarReducer;
